var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"crop-image-container"},[_c('vue-cropper',{ref:"cropper",attrs:{"alt":"Source Image","src":_vm.imgSrc}}),_vm._v(" "),_c('div',{staticClass:"crop-button text-center"},[_c('woot-button',{attrs:{"type":"button"},on:{"click":_vm.onCrop}},[_vm._v("\n      "+_vm._s(_vm.$t('MESSAGE_TYPE.FORM.IMAGE.CROP_BUTTON'))+"\n    ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }